exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "[data-v-9bbbf422] .img-wrapper{width:240px;height:240px;margin-left:10px}[data-v-9bbbf422] .el-dialog{width:300px}[data-v-9bbbf422] .el-dialog img{width:100%}\n", ""]);

